import {Component, NgZone, Input, Output, EventEmitter, ChangeDetectorRef} from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ComponentBase} from "../base/ComponentBase";
import {VocabularyEntry} from "../services/pipeline/vocabulary.pipeline.service";
import {CssWord} from "../content/content-view.objects";
import {RaVersion} from "../services/configuration/ra.version";

@Component({
    selector: "vocabulary-editor-multidetail",
    templateUrl: "./vocabulary.editor.multidetail.component.html",
    styleUrls: ["./pipeline.component.scss"]
})
// Editable view of a vocabulary term allowing user to select among multiple glossary terms and translations
export class VocabularyEditorMultiDetailComponent extends ComponentBase {

    @Output()
    public updateRequest:EventEmitter<VocabularyEntry> = new EventEmitter<VocabularyEntry>();

    @Output()
    public cancelRequest:EventEmitter<string> = new EventEmitter<string>();

    @Output()
    public searchRequest:EventEmitter<string> = new EventEmitter<string>();

    @Input()
    public idx:string;

    @Input()
    public vocabularyInfo:VocabularyEntry = null;

    @Input()
    public saveInProgress:boolean = false;

    @Input()
    public selectedWord:CssWord = null;

    constructor(private ref: ChangeDetectorRef) {
        super("VocabularyEditorMultiDetailComponent");
    }

    public changeDisabled():boolean {
        return this.saveInProgress || !this.vocabularyInfo.glossary;
    }

    public isNewEntry():boolean {
        return this.idx === "newVocabularyEntry";
    }
    public updateEntry(): void {
        this.updateRequest.emit(this.vocabularyInfo);
    }
    public cancelEntry(): void {
        this.cancelRequest.emit(this.idx);
    }
    public searchTerm(): void {
        this.searchRequest.emit(this.vocabularyInfo.word);
    }

    public setDefinition(definitionIndex: string): void {
        console.log("setting definition Index to:" + definitionIndex);
        if (Number(definitionIndex) !== this.vocabularyInfo.definitionIndex) {
            this.vocabularyInfo.setDataFromIndices(Number(definitionIndex), 0);
        }
        this.ref.detectChanges();
    }

    public setTranslation(translationIndex: string): void {
        console.log("setting translation Index to:" + translationIndex);
        this.vocabularyInfo.setDataFromIndices(this.vocabularyInfo.definitionIndex, Number(translationIndex));
        this.ref.detectChanges();
    }
}
